var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var demographicsFeatureConfigModel = require('./../demographics/demographicsFeatureConfigModel');
var billDetailsModalHeader = require('./../bill/billDetailsModalHeader.hbs');
var billDetailTemplate = require('./../bill/billDetailTemplate.hbs');
var launcherAppInterface = require('./../launcherApplicationInterface');
var applicationUtils = require('./../applicationUtils');
var ModalBehavior = require('./../widget/modal/ModalBehavior');
var paymentDetailsBillModalTemplate = require('./paymentDetailsBillModalTemplate.hbs');

/**
 * The paymentDetailsBillModalView serves as the modal view for displaying a bill's details.
 *
 * @class PaymentDetailsBillModalView
 * @extends Torso.View
 */
module.exports = TorsoView.extend({
  className: 'brec-dialog brec-dialog--big',

  moduleName: 'paymentDetailsBillModalView',
  attributes: {
    'role' : 'dialog',
    'data-view-name' : 'bill-details-modal'
  },
  template: paymentDetailsBillModalTemplate,
  headerTemplate: billDetailsModalHeader,
  bodyTemplate: billDetailTemplate,

  behaviors: {
    bill: {
      behavior: SecureMessageDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      alwaysFetch: true,
      id: { property: 'billId' }
    },

    modalBehavior: {
      behavior: ModalBehavior
    }
  },

  /**
   * Handles clicks on submit and back buttons
   * @events
   */
  events: {
    'click [data-close]': 'close',
    'touchstart [data-close]': 'close'
  },

  /**
   * @method initialize
   * @param {Object} args
   * @param {String} args.processId the process id associated with this payment process
   */
  initialize: function(args) {
    args = args || {};
    if (args.model) {
      this.model = args.model; //unneeded but clear that we expect a model.
    }
    this.set({
      closeLink: true,
      doneLoading: true
    });
    this.set('billId', args.billId);
    this.listenTo(demographicsFeatureConfigModel, 'load-complete', this.render);
    demographicsFeatureConfigModel.loadOnce();
    _.bindAll(this, 'keyEscape');
  },

  /**
   * @method prepare
   * @return {object} context the current PaymentModel's context
   */
  prepare: function() {
    var context = TorsoView.prototype.prepare.apply(this);

    context.isModal = true;
    context.showPaymentButton = false;

    var currentBillDataBehavior = this.getBehavior('bill');
    var useDataFromDataBehavior = currentBillDataBehavior.data.getModel();
    var currentBillModel = useDataFromDataBehavior ? currentBillDataBehavior.data.getModel() : this.model;
    // Adapter to make models set on this directly act like models from the data behavior.
    if (useDataFromDataBehavior && currentBillModel) {
      context.model = currentBillModel.toJSON();
    }

    if (currentBillModel) {
      context.servicesId = currentBillModel.get('servicesId');
      context.serviceDates = currentBillModel.getServiceDates();
      context.isPastDue = currentBillModel.isPastDue();
      _.each(currentBillModel.get('billDTO.patient.identifiers'), function(identifier) {
        if (identifier.sourceName === demographicsFeatureConfigModel.get('patientIdentifierDisplaySource')) {
          context.patientMrn = identifier.identifier;
        }
      });
    }

    context.currentApplication = applicationUtils.currentApplication;
    context.isAtHospital = launcherAppInterface.isAtHospital();
    return context;
  },

  /**
   * @method updateDOM
   */
  updateDOM: function() {
    var context = this.prepare();
    this.templateRender(this.$el, this.template, context);
    this.templateRender(this.$el.find('[data-dialog-heading]'), this.headerTemplate, context);
    this.templateRender(this.$el.find('[data-dialog-content]'), this.bodyTemplate, context);
  },

  /**
   * @method close
   */
  close: function() {
    this.rejectModal();
  },

  /**
   * @method _attached
   * @override
   */
  _attached: function() {
    $('body').on('keyup', this.keyEscape);
  },

  /**
   * @method _dispose
   * @override
   */
  _detached: function() {
    $('body').off('keyup', this.keyEscape);
  },

  /**
   * Close the modal if ESC is pressed.
   *
   * @method keyEscape
   * @param event {Object} key press event object
   */
  keyEscape: function(event) {
    if (this.isTopActive()) {
      var code = event.keyCode || event.which;
      if (code === 27) {
        this.close();
        return false;
      }
    }
  }
});
